import { universityRoutes } from '../module/University/router';

// Combine all module routes here
export const routes = [
    ...universityRoutes,
];
